import { frontendURL } from 'dashboard/helper/URLHelper.js';
import SettingsWrapper from 'dashboard/routes/dashboard/settings/SettingsWrapper.vue';
import SmartCampaignsPage from './pages/SmartCampaignsPage.vue';

const smartCampaignsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/smart_campaigns'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'smart_campaigns_index',
          meta: {
            permissions: ['administrator'],
          },
          component: SmartCampaignsPage,
        },
      ],
    },
  ],
};

export default smartCampaignsRoutes;
